"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrTravelDatesInformation = void 0;
const format_1 = __importDefault(require("date-fns/format"));
const de_1 = __importDefault(require("date-fns/locale/de"));
const fr_1 = __importDefault(require("date-fns/locale/fr"));
const react_1 = __importDefault(require("react"));
const libs_language_1 = require("@hotelplan/libs.language");
const fdr_travel_dates_styles_1 = require("./fdr-travel-dates.styles");
// HACK: french month's locale already includes dot for some reason
const TRAVEL_INFORMATION_DATE_FORMAT_DE = 'EEEEEE, d. MMM.';
const TRAVEL_INFORMATION_DATE_FORMAT_FR = 'EEEEEE, d. MMM';
function formatDateToTravelInformationFormat(date, language) {
    return (0, format_1.default)(date, language === 'fr'
        ? TRAVEL_INFORMATION_DATE_FORMAT_FR
        : TRAVEL_INFORMATION_DATE_FORMAT_DE, {
        locale: language === 'fr' ? fr_1.default : de_1.default,
    });
}
function FdrTravelDatesInformation({ departureDate, returnDate, duration, onlyDates, onlyDepartureDate, onlyReturnDate, language = libs_language_1.languageDefault, }) {
    return (react_1.default.createElement(fdr_travel_dates_styles_1.FdrTravelDatesInformationWrapper, { className: "travel-dates-information" },
        !onlyReturnDate && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { "data-id": "travelDatesInformationDepartureDate" }, formatDateToTravelInformationFormat(departureDate, language)),
            ' ')),
        !onlyDepartureDate && !onlyReturnDate ? react_1.default.createElement(react_1.default.Fragment, null, '- ') : null,
        !onlyDepartureDate && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { "data-id": "travelDatesInformationReturnDate" }, returnDate
                ? formatDateToTravelInformationFormat(returnDate, language)
                : '...'),
            ' ',
            !onlyDates && (react_1.default.createElement(react_1.default.Fragment, null,
                "/ ",
                react_1.default.createElement("span", { "data-id": "travelDatesInformationDuration" }, duration)))))));
}
exports.FdrTravelDatesInformation = FdrTravelDatesInformation;
//# sourceMappingURL=fdr-travel-dates-information.js.map